import { useClickOutside } from "@components/hooks/hooks"
import React, { useEffect, useRef, useState } from "react"

const CustomQty = ({ handleClickQty, qty, stock }) => {
  const [activeQty, setActiveQty] = useState(false)
  const [state, setState] = useState({
    qty: qty ?? 0,
    stock: stock ?? 0,
  })
  const qtyRef = useRef()

  useClickOutside(qtyRef, () => {
    if (activeQty) {
      setActiveQty(false)
    }
  })

  const handleClick = (type) => {
    if (handleClickQty) handleClickQty(type)

    if (type == "dec") {
      if (state.qty > 1)
        return setState((prev) => ({ ...prev, qty: state.qty - 1 }))
    } else if (type == "inc") {
      if (state.qty < state.stock) {
        return setState((prev) => ({ ...prev, qty: state.qty + 1 }))
      }
    } else if (typeof type === "number") {
      setActiveQty(false)
      return setState((prev) => ({ ...prev, qty: type }))
    }
  }

  useEffect(() => {
    setState((prev) => ({ ...prev, qty }))
  }, [qty])

  return (
    <div className="product-qty-adjustment">
      <div
        className={`btn-qty ${state.qty === 1 ? "disabled" : ""}`}
        onClick={() => handleClick("dec")}
      >
        -
      </div>
      <div className="wrapper-select-qty" ref={qtyRef}>
        <div
          className="wrapper-select-qty__label"
          onClick={() => setActiveQty(!activeQty)}
        >
          {state.qty}
        </div>
        <div
          className={`wrapper-select-qty__options ${activeQty ? "active" : ""}`}
        >
          <div className="wrapper-select-qty__options-list">
            {[...Array(state.stock)].map((_, i) => (
              <div
                className={`wrapper-select-qty__options-item ${
                  state.qty === i + 1 ? "active" : ""
                }`}
                key={i}
                role="button"
                tabIndex={0}
                onClick={() => handleClick(i + 1)}
              >
                <span className="wrapper-select-qty__options-item-label">
                  {i + 1}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div
        className={`btn-qty ${state.qty === state.stock ? "disabled" : ""}`}
        onClick={() => handleClick("inc")}
      >
        +
      </div>
    </div>
  )
}

export default CustomQty
